import React from 'react';
import PropTypes from 'prop-types';
import styles from './NavbarItem.module.css';

const NavbarItem = ({
                        id,
                        dataId,
                        isOpen,
                        isConfigMode,
                        onHover,
                        iconHover,
                        iconActive,
                        isSelected,
                        iconRest,
                        appName,
                        isHovered,
                        notifications,
                        onClick,
                        children
                    }) => {
    const handleClick = () => {
        if (onClick) onClick();
    };

    const handleMouseEnter = () => {
        if (onHover) onHover(appName);
    };

    const handleMouseLeave = () => {
        if (onHover) onHover(null);
    };

    // Determine which icon to show
    const getIconSrc = () => {
        if (isSelected) return iconActive;
        if (isHovered) return iconHover;
        return iconRest;
    };

    // Build className for appName based on states
    const getAppNameClasses = () => {
        const classes = [styles.appName];

        if (isOpen) classes.push(styles.isOpen);
        if (isHovered) classes.push(styles.isHovered);
        if (isSelected) classes.push(styles.isSelected);
        if (isConfigMode) classes.push(styles.isConfigMode);

        return classes.join(' ');
    };

    const getIconClasses = () => {
        const classes = [styles.icon];

        // Only apply config mode styling to non-config icons
        // if (isConfigMode && appName !== "Config Mode") {
        //     classes.push(styles.isConfigMode);
        // }
        if (isConfigMode && !isHovered && !isSelected) {
            classes.push(styles.isConfigMode);
        }

        return classes.join(' ');
    };

    return (
        <div
            id={id}
            data-id={dataId}
            className={styles.logoAndTextContainer}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onClick={handleClick}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    handleClick();
                }
            }}
        >
            {(!iconHover && !iconRest) ? (
                children
            ) : (
                <div className={styles.iconContainer}>
                    {notifications > 0 && (
                        <div className={styles.notification} aria-label={`${notifications} notifications`}>
                            {notifications}
                        </div>
                    )}
                    <img
                        data-id={`${dataId}_ICON`}
                        src={getIconSrc()}
                        alt={`${appName} icon`}
                        className={getIconClasses()}
                    />
                </div>
            )}

            <span className={getAppNameClasses()}>
                {appName}
            </span>
        </div>
    );
};

NavbarItem.propTypes = {
    id: PropTypes.string,
    dataId: PropTypes.string,
    isOpen: PropTypes.bool,
    isConfigMode: PropTypes.bool,
    onHover: PropTypes.func,
    iconHover: PropTypes.string,
    iconRest: PropTypes.string,
    iconActive: PropTypes.string,
    appName: PropTypes.string,
    onClick: PropTypes.func,
    notifications: PropTypes.number,
    isSelected: PropTypes.bool,
    isHovered: PropTypes.bool,
    children: PropTypes.node
};

NavbarItem.defaultProps = {
    isOpen: false,
    isConfigMode: false,
    isSelected: false,
    isHovered: false,
    notifications: 0
};

export default NavbarItem;